export class TradeName {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
    Inactive: boolean;
}

export default TradeName;